(() => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getGrid = () => document.querySelector('[data-alard-product-grid]');

  const getGroups = () => Array.from(getGrid()?.querySelectorAll('[data-product-group]') || []);

  const getCards = () => Array.from(getGrid()?.querySelectorAll('.product-card-alard') || []);

  const updateProductCount = (root) => {
    const countElement = root.querySelector('[data-alard-product-count]');
    const labelElement = root.querySelector('[data-alard-product-count-label]');
    if (!countElement) return;

    const visibleCount = getCards().filter((card) => !card.hidden).length;
    countElement.textContent = String(visibleCount);

    if (labelElement) {
      const singular = root.dataset.countLabelSingular || 'product';
      const plural = root.dataset.countLabelPlural || 'products';
      labelElement.textContent = visibleCount === 1 ? singular : plural;
    }
  };

  const applySizeFilter = (root, size) => {
    getCards().forEach((card) => {
      if (!size) {
        card.hidden = false;
        return;
      }
      const cardSizes = (card.dataset.sizes || '').split(' ');
      card.hidden = !cardSizes.includes(size);
    });

    getGroups().forEach((group) => {
      const visibleCards = Array.from(group.querySelectorAll('.product-card-alard')).filter((card) => !card.hidden);
      group.hidden = visibleCards.length === 0;
    });

    updateProductCount(root);
  };

  const scrollToGroup = (anchor) => {
    const target = anchor ? document.getElementById(anchor) : null;
    const behavior = prefersReducedMotion() ? 'auto' : 'smooth';

    if (target) {
      target.scrollIntoView({ behavior, block: 'start' });
      return;
    }

    const firstGroup = getGroups()[0];
    firstGroup?.scrollIntoView({ behavior, block: 'start' });
  };

  const initialize = (root) => {
    if (root.dataset.alardInitialized === 'true') return;
    root.dataset.alardInitialized = 'true';

    root.addEventListener('click', (event) => {
      const sizePill = event.target.closest('[data-alard-size-pill]');
      if (sizePill) {
        root.querySelectorAll('[data-alard-size-pill]').forEach((pill) => {
          const active = pill === sizePill;
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-pressed', String(active));
        });
        if (sizePill.dataset.targetAnchor) {
          applySizeFilter(root, '');
          scrollToGroup(sizePill.dataset.targetAnchor);
        } else {
          applySizeFilter(root, sizePill.dataset.size);
          if (!sizePill.dataset.size) scrollToGroup('');
        }
        return;
      }

      const categoryTile = event.target.closest('[data-alard-category-tile]');
      if (categoryTile) {
        root.querySelectorAll('[data-alard-category-tile]').forEach((tile) => {
          const active = tile === categoryTile;
          tile.classList.toggle('is-active', active);
          tile.setAttribute('aria-pressed', String(active));
        });
        scrollToGroup(categoryTile.dataset.targetAnchor);
      }
    });

    updateProductCount(root);
  };

  document.querySelectorAll('[data-alard-collection-family]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-alard-collection-family]').forEach(initialize);
  });
})();
